module.exports = __webpack_public_path__ + "static/media/flower-allo-projects-alt.ae0365d4.png";